import { useMemo } from 'react';

import { authMiddleware } from '../middleware/auth-middleware';
import { buildRequestMiddleware } from '../middleware/build-request-middleware';
import { fetchMiddleware } from '../middleware/fetch-middleware';
import { graphqlRouterMiddleware } from '../middleware/graphql-router-middleware';
import { EnvironmentConfigType } from '../relay-types';
import { useEnvironment } from './use-environment';

export const useWebEnvironment = (config: EnvironmentConfigType) => {
    const creators = useMemo(
        () => [buildRequestMiddleware, authMiddleware, graphqlRouterMiddleware, fetchMiddleware],
        [],
    );
    return useEnvironment(config, creators);
};
